import React from "react";
import PropTypes from "prop-types";
import useAuth from "../../hooks/useAuth";

export default function PermissionGuard({
  permission,
  children,
  fallback = <div style={{ padding: 24 }}>403 - Access denied</div>,
}) {
  const { hasPermission, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: 24 }}>Loading...</div>;
  }

  if (!hasPermission(permission)) {
    return fallback;
  }

  return children;
}

PermissionGuard.propTypes = {
  permission: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};
